"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIf = void 0;
const openfga_client_1 = require("./openfga-client");
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const userChecks = (id) => ({
    owns: {
        contact: async (contactId) => {
            return await (0, openfga_client_1.check)(`user:${id}`, "owns", `contact:${contactId}`);
        },
    },
    can_edit: {
        contact: async (contactId) => {
            return await (0, openfga_client_1.check)(`user:${id}`, "can_edit", `contact:${contactId}`);
        },
        note: async (noteId) => {
            return await (0, openfga_client_1.check)(`user:${id}`, "can_edit", `note:${noteId}`);
        },
    },
    can_view: {
        contact: async (contactId) => {
            return await (0, openfga_client_1.check)(`user:${id}`, "can_view", `contact:${contactId}`);
        },
    },
    can_access: {
        feature: async (featureName) => {
            return await (0, openfga_client_1.check)(`user:${id}`, "access", `feature:${featureName}`);
        },
    },
    can_view_all_contacts_in: {
        organization: async (orgId) => {
            return await (0, openfga_client_1.check)(`user:${id}`, "can_view_all_contacts", `organization:${orgId}`);
        },
    },
    can_edit_all_contacts_in: {
        organization: async (orgId) => {
            return await (0, openfga_client_1.check)(`user:${id}`, "can_edit_all_contacts", `organization:${orgId}`);
        },
    },
    has_elevated_access_in: {
        organization: async (orgId) => {
            return await (0, openfga_client_1.check)(`user:${id}`, "elevated_access", `organization:${orgId}`);
        },
    },
    has_full_access_in: {
        organization: async (orgId) => {
            return await (0, openfga_client_1.check)(`user:${id}`, "full_access", `organization:${orgId}`);
        },
    },
});
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const organizationChecks = (id) => ({
    can_access: {
        feature: async (featureName) => {
            return await (0, openfga_client_1.check)(`organization:${id}`, "access", `feature:${featureName}`);
        },
    },
});
exports.checkIf = {
    user: userChecks,
    organization: organizationChecks,
};
//# sourceMappingURL=checks.js.map